module.exports = __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-87b9e5a7e0e30316330d662738e6f545.webp";